module.exports = __webpack_public_path__ + "img/concrete-hole-decal-03.b46c113a.png";